<script>
	export let local, campaigns;
	import Campaign from './Campaign.svelte';
</script>

<svelte:head>
<title>#ShareMyCheck {local}</title>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=UA-161008668-2"></script>
<script>
	window.dataLayer = window.dataLayer || [];
	function gtag(){dataLayer.push(arguments);}
	gtag('js', new Date());
	gtag('config', 'UA-161008668-2');
</script>
</svelte:head>

<main>
	<h1 class="site-title">#ShareMyCheck<br>{local}</h1>
	<h4>Donate your stimulus check to local, grassroots COVID-19 mutual aid and relief.</h4>
	<h4>Inspired by the <a href="https://www.sharemycheck.org/">#ShareMyCheck</a> campaign by <a href="https://resourcegeneration.org/">Resource Generation</a>.</h4>
	<hr>
	{#each campaigns as campaign}
	<Campaign campaign={campaign}/>
	{/each}
</main>
<footer>
	<p>Compiled by <a href="https://www.weallwegotsd.com/">We All We Got SD</a>, QTBIPOC-centered mutual aid on occupied Kumeyaay Land, San Diego County, California.</p>
</footer>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
		border-top: 5px solid #ff3e00;
		max-width: none;
	}

	h1.site-title {
		color: #ff3e00;
		font-size: 2.5em;
		font-weight: 100;
	}

	h4 {
		font-weight: 300;
		font-size: 1.1em;
		margin: 0 auto;
		max-width: 400px;
		margin-bottom: 1em;
	}
	hr {
		border-width: 0;
		background: #ddd;
		color: #ddd;
		height: 1px;
		margin: 30px 0;
	}
	footer {
		width: 100%;
		padding: 3em 0 5em;
		font-size: 0.9em;
		text-align: center;
		border-bottom: 5px solid #ff3e00;
	}
	footer p {
		margin: 0px auto;
		color: #666;
		max-width: 50%;
	}


	@media (min-width: 640px) {
		main {
			max-width: none;
		}

		h1.site-title {
			font-size: 3em;
		}
	}

	@media (max-width: 640px) {
		h1.nothing {
			font-size: 1em !important;
		}
	}

</style>
